import { Quote } from "lucide-react";

export default function ImpactStory() {
  return (
    <section
      id="impact"
      data-testid="impact-section"
      className="relative py-20 md:py-32 bg-forest text-cream overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
          <div className="md:col-span-6 order-2 md:order-1">
            <p className="overline mb-6 text-mustard">Story #047</p>
            <h2 className="text-4xl md:text-5xl lg:text-6xl text-cream leading-tight text-balance">
              "We didn't need rescue. We needed someone to listen — and stay."
            </h2>

            <div className="mt-10 space-y-5 text-cream/85 md:text-lg leading-relaxed">
              <p>
                In Lallubhai Compound, eleven women started a savings circle in
                2019. UrbanRise didn't fund it — they joined it. Six years later,
                that circle owns three tailoring units, a library, and runs the
                ward's only paid childcare cooperative.
              </p>
              <p className="flex items-start gap-3">
                <Quote
                  size={22}
                  className="text-terracotta flex-shrink-0 mt-1"
                  strokeWidth={1.5}
                />
                <span className="italic font-serif text-2xl leading-snug text-cream">
                  This is what dignity looks like — quiet, daily, ours.
                </span>
              </p>
            </div>

            <div className="mt-10 flex items-center gap-4">
              <img
                src="/imgs/indian-portrait-2.jpg"
                alt="Asha"
                className="w-14 h-14 rounded-full object-cover border-2 border-mustard"
              />
              <div>
                <p className="font-serif text-xl text-cream leading-none">
                  Asha Pawar
                </p>
                <p className="overline text-mustard mt-2">
                  Convenor, Lallubhai Mahila Mandal
                </p>
              </div>
            </div>
          </div>

          <div className="md:col-span-6 order-1 md:order-2 relative">
            <div className="aspect-[4/5] overflow-hidden grain">
              <img
                src="/imgs/indian-children-classroom.jpg"
                alt="Children at a community learning session"
                className="w-full h-full object-cover"
                data-testid="impact-image"
              />
            </div>
            <div className="hidden md:flex absolute -bottom-8 -left-8 bg-mustard text-ink px-6 py-4 flex-col">
              <p className="font-serif text-4xl leading-none">₹14.2L</p>
              <p className="overline mt-2">Circle savings — Dec '25</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
